// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/product_categories/kv
 *
 * Returns the active product categories projected into a flat list of
 * `{ value, label }` select-options.
 *
 * @see ProductCategories_KvOptionRow
 */
import type { ProductCategories_KvOptionRow } from './ProductCategories_KvOptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductCategories_KvResponseDados = ProductCategories_KvOptionRow[];

export type ProductCategories_KvResponse = ApiResponse<ProductCategories_KvResponseDados>;

registerResponseContract('ProductCategories_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
